import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'I used the three-step protocol the night I downloaded this. My son was starting to escalate after bath time. I ran Stage 1 on myself first — just like it says — and I could feel the difference in how I re-entered the room. He came down in under eight minutes. That has never happened before.',
    author: 'Mother of a 6-year-old',
    location: 'Texas'
  }, {
    quote: "As a special education teacher and a dad, I was skeptical. But the Yellow Zone Map alone was worth every penny. I started using it at home and then shared the framework with my son's classroom aide. It changed our mornings completely.",
    author: 'Father of a 9-year-old',
    location: 'Ohio'
  }, {
    quote: "I've spent thousands on therapy, courses and consultations. This $27 guide explained my daughter's nervous system better than anything I've encountered in four years of searching.",
    author: 'Mother of a 7-year-old',
    location: 'California'
  }];
  return <section className="w-full py-24 px-6 md:px-12 lg:px-24 bg-sage-light" data-id="element-200">
      <div className="max-w-6xl mx-auto" data-id="element-201">
        <div className="grid md:grid-cols-3 gap-8" data-id="element-202">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-white p-8 rounded-3xl shadow-sm relative" data-id="element-203">
              <Quote className="w-10 h-10 text-amber/20 absolute top-6 left-6" data-id="element-204" />
              <div className="relative z-10 pt-6" data-id="element-205">
                <p className="text-charcoal-light text-lg italic leading-relaxed mb-8" data-id="element-206">
                  "{t.quote}"
                </p>
                <div className="border-t border-cream-dark pt-4" data-id="element-207">
                  <p className="font-semibold text-charcoal" data-id="element-208">{t.author}</p>
                  <p className="text-sm text-charcoal-light" data-id="element-209">{t.location}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}